import { Component, Input } from "@angular/core";

@Component({
  selector: "bf-limit-counter",
  template: `
    <span class="badge" [class.badge-warning]="isLimitReached" [class.badge-info]="!isLimitReached">
      {{ count }}/{{ limit }} {{ name || '' }}
    </span>
  `,
  styles: [
    `
      .badge {
        font-size: 14px;
      }
      .badge-info {
        background-color: var(--my-color-violet);
      }
      .badge-warning {
        background-color: #ffc107;
      }
    `,
  ],
})
export class LimitCounterComponent {
  @Input() count: number = 0;
  @Input() limit: number = 0;
  @Input() name: string;

  get isLimitReached(): boolean {
    return this.count >= this.limit;
  }
}
